import { ACTIVE_BROKERS_DOMAINS } from '../types.type';

export const suggestedBrokers = [
  {
    id: ACTIVE_BROKERS_DOMAINS.UPSTOX,
    img: '/images/brokers/upstocks-icon.svg',
  },
  {
    id: ACTIVE_BROKERS_DOMAINS.KOTAKNEO,
    img: '/images/brokers/kotak-neo.svg',
  },
  {
    id: ACTIVE_BROKERS_DOMAINS.STOCKO,
    img: '/images/brokers/stocko.svg',
  },
  {
    id: ACTIVE_BROKERS_DOMAINS.ANGELONE,
    img: '/images/brokers/angel-one-icon.svg',
  },
  {
    id: ACTIVE_BROKERS_DOMAINS.FLATTRADE,
    img: '/images/brokers/flattrade-icon.svg',
  },
  {
    id: ACTIVE_BROKERS_DOMAINS.DHAN,
    img: '/images/brokers/dhan-icon.svg',
  },
];
